/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { FormStructure } from '@master/model/structure/FormStructure'
import { Shared, SharedField } from '@core/model/recruit/forms/Shared'
import { FormBaseMixin } from './FormBaseMixin'
@Component
export class SharedFormMixin extends FormBaseMixin {
  protected type = Shared

  get sharedInfoStructure (): FormStructure<SharedField> {
    return [
      {
        label: 'Name',
        key: 'name'
      },
      {
        label: 'NRIC',
        key: 'nric'
      },
      {
        label: 'Branch Code',
        key: 'branch',
        disabled: true
      },
      {
        label: 'RNF Number',
        key: 'rnfNumber'
      },
      {
        label: 'Email',
        key: 'corporateEmail'
      },
      {
        label: 'H/P Number',
        key: 'hpNumber'
      },
      {
        label: 'Recruiting Manager',
        key: 'rm'
      },
      {
        label: 'Financial Services Manager',
        key: 'fsm'
      }
    ]
  }
}
